import { render, staticRenderFns } from "./applicationEvents.vue?vue&type=template&id=bab01e04&scoped=true"
import script from "./applicationEvents.vue?vue&type=script&lang=js"
export * from "./applicationEvents.vue?vue&type=script&lang=js"
import style0 from "./applicationEvents.vue?vue&type=style&index=0&id=bab01e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab01e04",
  null
  
)

export default component.exports